<div class="lp-text" style="position: relative; white-space: pre-wrap">
  <!-- NOTE: since the text is typing slowly, we need to know the correct size of the parent. That's why this (invisible) copy of the message is here. -->
  @for (part of textObject().parts; track $index) {
    <span style="visibility: hidden" [style]="part.style">{{ part.content }}</span>
  }
  <!-- NOTE: this is the text that is shown to the user -->
  <div style="position: absolute; inset: 0">
    @for (part of shownText().parts; track $index) {
      <span [style]="part.style">{{ part.content }}</span>
    }
  </div>
</div>
